(function ($) {
	var methods = {
		init: function () {
			return this.each(function () {
				var $this = $(this);
				var data = $this.data('inputInn');

				$this.checkInn = function () {
					var inn = $this.val();
					var isValid = false;
					if (typeof inn === 'number') {
						inn = inn.toString();
					} else if (typeof inn !== 'string') {
						inn = '';
					}
					if (!inn.length) {
						//ИНН пуст
						if(!$this.prop("required")){
							isValid = true;
						}
					} else if (/[^0-9]/.test(inn)) {
						//ИНН может состоять только из цифр
					} else if ([10, 12].indexOf(inn.length) === -1) {
						//ИНН может состоять только из 10 или 12 цифр
					} else if (inn === '0000000000' || inn === '000000000000') {
						//ИНН не может состоять из нулей;
					} else {
						var checkDigit = function (inn, coefficients) {
							var n = 0;
							for (var i in coefficients) {
								n += coefficients[i] * inn[i];
							}
							return parseInt(n % 11 % 10);
						};
						switch (inn.length) {
							case 10:
								var n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
								if (n10 === parseInt(inn[9])) {
									isValid = true;
								}
								break;
							case 12:
								var n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
								var n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
								if ((n11 === parseInt(inn[10])) && (n12 === parseInt(inn[11]))) {
									isValid = true;
								}
								break;
						}
					}
					$this.toggleClass("invalid", !isValid);
				};

				if (!data) {
					if ($this.val().length > 0) {
						$this.checkInn();
					}
					$this.data('inputInn', {
						target: $this
					});
					$this.on('input.inputInn', function (event) {
						
						event = event.originalEvent || event;
						var target = event.target;
						var value = target.value;
						var cursor = target.selectionStart;

						target.classList.toggle("invalid", false);

						var res = value.replace(/[^0-9]/g, '').substr(0, 12);
						target.value = res;
						target.selectionStart = cursor;
						target.selectionEnd = cursor;

						event.preventDefault();
						event.stopPropagation();
						event.stopImmediatePropagation();
					});
					$this.on("focusout.inputInn change.inputInn", $this.checkInn);
				}

			});

		},
		destroy: function () {
			return this.each(function () {
				var $this = $(this);
				$this.removeData('inputInn');
				$(window).unbind('.inputInn');
			});

		}
	};
	$.fn.inputInn = function (method) {
		if (methods[method]) {
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof method === 'object' || !method) {
			return methods.init.apply(this, arguments);
		} else {
			$.error('Метод с именем ' + method + ' не существует для jQuery.inputInn');
		}
	};
})(jQuery);


